import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const StyledHr = styled.hr`
  border: 1px solid ${colors.geyser};
  border-bottom: none;
  width: 100%;
`;
